import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { SharedService } from "../../../component/shared/shared.service";
import { ActivatedRoute } from "@angular/router";
import { UserDetail, UserClinic, UserAccount } from "../model/user-detail";
import { AuthServiceService } from "../../../component/service/auth-service.service";
import { User } from "../model/user";
import { UserService } from "../service/user.service";
import { Role } from "../../master/model/role";
import { Organization } from "../../master/model/organization";
import { Specialize } from "../../master/model/specialize";
import { Clinic } from "../../master/model/clinic";
import { RoleMasterService } from "../../master/services/role-master.service";
import { SpecializeMasterService } from "../../master/services/specialize-master.service";
import { ServiceMasterService } from "../../master/services/service-master.service";
import { ClinicMasterService } from "../../master/services/clinic-master.service";
import { OrganizationMasterService } from "../../master/services/organization-master.service";
import {
  DialogAction,
  ActionMessage
} from "../../../shared/enum/dialog-action.enum";
import { ColorPickerService, Cmyk } from "ngx-color-picker";
import { InternalFormsSharedModule } from "@angular/forms/src/directives";
@Component({
  selector: "app-create-user",
  templateUrl: "./create-user.component.html",
  styleUrls: ["./create-user.component.css"]
})
export class CreateUserComponent implements OnInit {
  usrData: UserDetail = new UserDetail(
    null,
    "",
    "",
    "",
    "",
    null,
    "",
    "",
    "",
    null,
    "",
    "",
    "",
    "",
    "",
    "",
    null,
    "",
    "Mr.",
    null,
    "",
    null,
    "#2883e9",
    "",
    "",
    "",
    "",
    null,
    "",
    null
  );
  loading: boolean = false;
  userAcc: UserAccount = new UserAccount(null, "", "", "", "", "");
  filesData: any[];
  text: string;
  service: string = "";
  profilePic: any;
  userClinic: UserClinic;
  listLoading: boolean = false;
  message: string = "";
  UserDetails: UserDetail[];
  organizations: Organization[];
  clinics: Clinic[];
  countries: any[];
  timezones: any[] = [];
  states: any[];
  selectedObject: UserDetail;
  userServices: Array<any> = [];
  services: Array<any> = [];
  isAdd: boolean = true;
  roleList: Role[];
  Users: UserDetail[];
  specializeList: Specialize[];
  clinicData: string[];
  dopdownData: any;
  isSuperAdmin: boolean = false;
  isDoctor: boolean = false;
  isBDA: boolean = false;
  isAssistant: boolean = false;
  private sub: any;
  public toggle: boolean = false;
  authService: AuthServiceService;
  public rgbaText: string = "rgba(165, 26, 214, 0.2)";
  files: any[] = [];
  isShowEye = false;
  documents: any[] = [
    { fileName: "", id: 0 },
    { fileName: "", id: 0 },
    { fileName: "", id: 0 }
  ];
  public arrayColors: any = {
    color1: "#2883e9",
    color2: "#e920e9",
    color3: "rgb(255,245,0)",
    color4: "rgb(236,64,64)",
    color5: "rgba(45,208,45,1)"
  };

  public cmykColor: Cmyk = new Cmyk(0, 0, 0, 0);
  constructor(
    authorizationService: AuthServiceService,
    private _sharedService: SharedService,
    private _usrService: UserService,
    public roleSrv: RoleMasterService,
    public specSrv: SpecializeMasterService,
    public orgSrv: OrganizationMasterService,
    public clnSrv: ClinicMasterService,
    private route: ActivatedRoute,
    private cpService: ColorPickerService,
    private router: Router,
    private srvSerrvice: ServiceMasterService
  ) {
    this.authService = authorizationService;
    this.isAdd = true;
    this.usrData.UserPlan = "NONE";
    this.usrData.UserWebsite = "";
    if (this.authService.getUserRole() === "1") {
      this.isSuperAdmin = true;
    } else if (this.authService.getUserRole() === "2") {
      this.isDoctor = true;
    } else if (this.authService.getUserRole() === "3") {
      this.isAssistant = true;
    } else if (this.authService.getUserRole() === "4") {
      this.isBDA = true;
    }
    _sharedService.yesEmitted$.subscribe(text => {
      if (
        text.Action === DialogAction.DELETE.toString() &&
        text.Page === "USER"
      ) {
      } else {
        this.clearData();
      }
    });
    this.dopdownData = {
      UserRoleId: "",
      SpecializationId: "",
      OrganizationId: "",
      CountryID: "",
      Timezone: ""
    };
    this.addFiles();
  }
  getUsers(id: number): void {
    this.loading = true;
    this._usrService.getUsersProfile(id).subscribe(
      data => {
        this.loading = false;
        this.Users = data;
        this.isAdd = false;

        if (id != undefined && id != null) {
          if (data.length > 0) {
            this.usrData = this.Users[0];
            this.usrData.UserPassword = "";
            if (this.usrData.AccountDetail != null) {
              this.userAcc = this.usrData.AccountDetail;
            } else {
              this.userAcc = new UserAccount(null, "", "", "", "", "");
            }

            this.usrData.UserPassword = "";
            if (this.usrData.Experience == "0") {
              this.usrData.Experience = "";
            }

            this.dopdownData.UserRoleId = this.usrData.UserRoleId;
            this.dopdownData.SpecializationId = this.usrData.SpecializationId;
            this.dopdownData.OrganizationId = this.usrData.OrganizationId;
            this.dopdownData.CountryID = this.usrData.CountryID;
            this.dopdownData.Timezone = this.usrData.Timezone;
            this.services = [];
            this.usrData.UserServices.forEach(element => {
              this.userServices.push({
                ServiceId: element.ServiceId,
                SpecializeId: this.usrData.SpecializationId,
                UserId: 0
              });
            });
            this.getCountry();
            this.GetServices(this.usrData.SpecializationId);
            this.loadClinic();
            this.getUserDocument(id);
          }
        }
      },
      error => {
        this.loading = false;
        this.message = error.data;
      }
    );
  }
  GetServices(specid: number) {
    this.services = [];
    if (this.isAdd) {
      this.userServices = [];
    }
    this.srvSerrvice.getServiceDetail(specid).subscribe(data => {
      data.forEach(element => {
        if (this.isAdd) {
          this.services.push({
            Checked: true,
            ServiceId: element.ServiceId,
            ServiceName: element.ServiceName
          });
          this.userServices.push({
            ServiceId: element.ServiceId,
            SpecializeId: specid,
            UserId: 0,
            ActionStatus: 1
          });
        } else {
          let srvData = this.userServices.filter(
            item => item.ServiceId == element.ServiceId
          );
          let flag = false;
          if (srvData.length > 0) {
            flag = true;
          }
          this.services.push({
            Checked: flag,
            ServiceId: element.ServiceId,
            ServiceName: element.ServiceName
          });
        }
      });
    });
  }
  cancelData() {
    this.router.navigate(["main/user/viewuser"]);
  }
  onChangeFile(event: EventTarget, index: number) {
    let eventObj: MSInputMethodContext = <MSInputMethodContext>event;
    let target: HTMLInputElement = <HTMLInputElement>eventObj.target;
    let files: FileList = target.files;
    this.files[index].file = files[0];
    this.files[index].text = files[0].name;
  }
  GetState() {
    this.states = [];
    let data = this.countries.filter(
      item => item.Value == this.dopdownData.CountryID
    )[0];
    if (data) {
      this.states = data.State;
      if (this.isAdd) {
        this.usrData.StateId = 0;
      }

      this.usrData.CountryCode = data.Code;
    }
  }
  clearData(): void {
    this.usrData.UserName = "";
    this.usrData.UserPassword = null;
    this.usrData.UserRoleId = null;
    this.usrData.UserRole = "";
    this.usrData.SpecializationId = null;
    this.usrData.FirstName = "";
    this.usrData.LastName = "";
    this.usrData.Gender = "";
    this.usrData.Email = "";
    this.usrData.UserAddress = "";
    this.usrData.ContactNo = null;
    this.usrData.Type = "Mr.";
    this.usrData.UserRePassword = "";
    this.usrData.LinkedInProfile = "";
    this.usrData.FacebookProfile = "";
    this.usrData.OrganizationId = null;
    this.usrData.UserClinic = null;
    this.usrData.GooglePlusProfile = "";
    this.usrData.InstagramProfile = "";
    this.usrData.VideoPath = "";
    this.usrData.UserWebsite = "";
    this.usrData.TwitterProfile = "";
    this.usrData.UserRoleId = null;
    this.clinicData = [];
    this.clinics = [];
    this.userAcc.AccountName = "";
    this.userAcc.AccountNo = "";
    this.userAcc.BankName = "";
    this.userAcc.BranchName = "";
    this.userAcc.IFSCCode = "";
    this.usrData.UserPlan = "NONE";
    this.isAdd = true;
    this.usrData.CountryCode = 0;
    this.usrData.CountryID = 0;
    this.usrData.StateId = 0;
  }
  saveUser(): void {
    this.usrData.UserRoleId = this.dopdownData.UserRoleId;
    this.usrData.SpecializationId = this.dopdownData.SpecializationId;
    this.usrData.OrganizationId = this.dopdownData.OrganizationId;
    this.usrData.CountryID = this.dopdownData.CountryID;
    this.usrData.AccountDetail = this.userAcc;
    this.usrData.Timezone = this.dopdownData.Timezone;
    if (this.usrData.Experience == "") {
      this.usrData.Experience = "0";
    }
    this._usrService.data = this.usrData;

    if (this.usrData.UserPassword) {
      var passw = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,20}$/;
      if (!this.usrData.UserPassword.match(passw)) {
        alert(
          "Password should be at least 6 digit which contain at least one numeric digit, one uppercase and one lowercase letter!"
        );
        return;
      }
      if (this.usrData.UserPassword !== this.usrData.UserRePassword) {
        alert("Password and Confirm password should be same!");
        return;
      }
    }

    if (this.isAdd) {
      this.usrData.UserPlan = "BASIC";
      if (this.usrData.UserName.replace(/\s/g, "") == "") {
        alert("Please enter userame!");
        return;
      }
      if (this.usrData.UserPassword.replace(/\s/g, "") == "") {
        alert("Please enter password!");
        return;
      }
      var passw = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,20}$/;
      if (!this.usrData.UserPassword.match(passw)) {
        alert(
          "Password should be at least 6 digit which contain at least one numeric digit, one uppercase and one lowercase letter!"
        );
        return;
      }
      if (this.usrData.FirstName.replace(/\s/g, "") == "") {
        alert("Please enter first name!");
        return;
      }
      if (this.usrData.LastName.replace(/\s/g, "") == "") {
        alert("Please enter last name!");
        return;
      }
      if (this.usrData.Gender.replace(/\s/g, "") == "") {
        alert("Please select gender!");
        return;
      }

      if (this.usrData.UserRoleId.toString().replace(/\s/g, "") == "") {
        alert("Please select role!");
        return;
      }

      /*if (this.usrData.UserPlan.toString().replace(/\s/g, "") == "") {
          alert("Please select payment plan!");
          return;
        }*/

      if (this.usrData.UserRoleId.toString().replace(/\s/g, "") == "") {
        alert("Please select role!");
        return;
      }
      if (this.usrData.SpecializationId.toString().replace(/\s/g, "") == "") {
        alert("Please select specialization!");
        return;
      }
      if (this.usrData.Email.replace(/\s/g, "") == "") {
        alert("Please enter email!");
        return;
      }
      if (
        this.usrData.ContactNo == null ||
        this.usrData.ContactNo == 0 ||
        this.usrData.ContactNo.toString().replace(/\s/g, "") == ""
      ) {
        alert("Please enter phone no!");
        return;
      }
      if (this.usrData.CountryID == 0) {
        alert("Please select country!");
        return;
      }
      if (this.usrData.StateId == 0) {
        alert("Please select state!");
        return;
      }
      if (this.usrData.Timezone == "") {
        alert("Please select timezone!");
        return;
      }
      this.loading = true;
      this.addUser();
    } else {
      if (this.usrData.Email.replace(/\s/g, "") == "") {
        alert("Please enter email!");
        return;
      }
      if (
        this.usrData.ContactNo == null ||
        this.usrData.ContactNo == 0 ||
        this.usrData.ContactNo.toString().replace(/\s/g, "") == ""
      ) {
        alert("Please enter phone no!");
        return;
      }
      if (this.usrData.CountryID == 0) {
        alert("Please select country!");
        return;
      }
      if (this.usrData.StateId == 0) {
        alert("Please select state!");
        return;
      }

      if (this.usrData.Timezone == "") {
        alert("Please select timezone!");
        return;
      }
      this.loading = true;
      this.updateUser();
    }
  }
  saveDocument() {
    this._usrService.docData = {
      UserId: this.usrData.UserId,
      REGISTRATIONNO: this.usrData["RegistrationNo"]
    };
    this.filesData = [];
    if (this.files[0].file != null) {
      this.filesData.push({ file: this.files[0].file, text: "DEGREE1" });
    }
    if (this.files[1].file != null) {
      this.filesData.push({ file: this.files[1].file, text: "DEGREE2" });
    }
    if (this.files[2].file != null) {
      this.filesData.push({ file: this.files[2].file, text: "DEGREE3" });
    }
    if (this.files[3].file != null) {
      this.filesData.push({ file: this.files[3].file, text: "REGISTRATION" });
    }
    if (this.files[4].file != null) {
      this.filesData.push({ file: this.files[4].file, text: "SIGNATURE" });
    }

    this._usrService.document = this.filesData;
    this._usrService.saveDocuments().subscribe(
      data => {
        this.addFiles();
      },
      error => {
        this.message = error.data;
      }
    );
  }
  addFiles() {
    this.files.push({ text: "", file: null });
    this.files.push({ text: "", file: null });
    this.files.push({ text: "", file: null });
    this.files.push({ text: "", file: null });
    this.files.push({ text: "", file: null });
  }
  updateDocument(no: string, regimg: string, sig: string, index: number) {
    this._usrService.docData = {
      UserId: this.usrData.UserId,
      RegistrationNo: no,
      RegistrationImage: regimg,
      Signature: sig
    };
    this._usrService.updateDocument().subscribe(data => {});
  }
  getUserDocument(id: number) {
    for (let i = this.documents.length - 1; i >= 0; i--) {
      this.documents[i].fileName = "";
      this.documents[i].id = 0;
    }
    this._usrService.getUserDocument(id).subscribe(data => {
      for (let i = data.length - 1; i >= 0; i--) {
        this.documents[i].fileName = data[i].DegreePath;
        this.documents[i].id = data[i].DegreeAutoId;
      }
    });
  }

  deleteDocument(id: number, index: number) {
    this._usrService.deleteUserDocument(id).subscribe(data => {
      this.documents[index].fileName = "";
      this.documents[index].id = 0;
    });
  }

  addUser(): void {
    this.loading = true;
    this.usrData.UserClinic = [];
    this.usrData.UserServices = this.userServices;
    /*for(let i=0; i<this.clinicData.length;i++){
      this.userClinic = new UserClinic(null,parseInt(this.clinicData[i]),null,'')
      this.usrData.UserClinic.push(this.userClinic);
     }*/
    this._usrService.saveUser().subscribe(
      data => {
        this.loading = false;
        this.message = "User " + ActionMessage.SAVESUCCESS.toString();
        this.clearData();
        //this.saveDocument();
        if (this.profilePic != undefined) {
          this.updateProfilePic(data.UserId, data.UserRole);
        }
        /*else {
          if(data.UserRole != "") {
            setTimeout(() => {
              window.location.href="../../../../Subscription.aspx?order=" + data.UserRole;
            }, 1000);
           
           //window.location.href="http://localhost:59938/Subscription.aspx?order=" + data.UserRole;
          }
            
        }*/
      },
      error => {
        this.loading = false;

        if (JSON.parse(error._body).Message === undefined) {
          this.message = error._body;
        } else {
          this.message = JSON.parse(error._body).Message;
        }
      }
    );
  }
  loadClinic() {
    if (this.dopdownData.OrganizationId == "") {
      this.clinics = [];
    }
    this.clnSrv
      .getClinicForOrganization(this.dopdownData.OrganizationId)
      .subscribe(
        data => {
          this.clinics = data;
          this.clinicData = [];
          if (this.sub != null && this.usrData.UserClinic != null) {
            for (let i = 0; i < this.usrData.UserClinic.length; i++) {
              this.clinicData.push(
                this.usrData.UserClinic[i].AssociateClinicId.toString()
              );
            }
          }
        },
        error => {
          if (error.data.Message === undefined) {
            this.message = error.data;
          } else {
            this.message = error.data.Message;
          }
        }
      );
  }
  onChange(event: EventTarget) {
    let eventObj: MSInputMethodContext = <MSInputMethodContext>event;
    let target: HTMLInputElement = <HTMLInputElement>eventObj.target;
    let files: FileList = target.files;
    this.profilePic = files[0];
    this.text = files[0].name;
  }
  getUserDetail() {
    this._usrService.getUserProfile().subscribe(
      data => {
        if (data.length > 0) {
          sessionStorage.setItem("User", JSON.stringify(data[0]));
          window.location.reload();
        }
      },
      error => {}
    );
  }
  updateProfilePic(id: number, bookingNumber: string) {
    this._usrService.data.UserId = id;
    this.filesData = [];

    this.filesData.push(this.profilePic);
    this._usrService.profilePic = this.filesData;
    this._usrService.saveUserProfile().subscribe(
      data => {
        this.loading = false;
        this.profilePic = null;
        this.text = "";

        if (bookingNumber != "") {
          // window.location.href="../../../../Subscription.aspx?order=" + bookingNumber;
          //window.location.href="http://localhost:59938/Subscription.aspx?order=" + bookingNumber;
        }
        this.getUserDetail();
      },
      error => {
        this.loading = false;
        if (JSON.parse(error._body).Message === undefined) {
          this.message = error._body;
        } else {
          this.message = JSON.parse(error._body).Message;
        }
        if (bookingNumber != "") {
          // window.location.href="../../../../Subscription.aspx?order=" + bookingNumber;
          //window.location.href="http://localhost:59938/Subscription.aspx?order=" + bookingNumber;
        }
      }
    );
  }
  updateUser(): void {
    this.loading = true;
    this.usrData.UserClinic = [];
    this.usrData.AccountDetail = this.userAcc;
    for (let i = 0; i < this.clinicData.length; i++) {
      this.userClinic = new UserClinic(
        null,
        parseInt(this.clinicData[i]),
        null,
        ""
      );
      this.usrData.UserClinic.push(this.userClinic);
    }
    this._usrService.data = this.usrData;
    let srvData = this.usrData.UserServices;
    srvData.forEach(element => {
      let ind = this.userServices.findIndex(
        item => item.ServiceId == element.ServiceId
      );
      let flag = 2;
      if (ind == -1) {
        this.userServices.push({
          ServiceId: element.ServiceId,
          SpecializeId: this.usrData.SpecializationId,
          UserId: this.usrData.UserId,
          ActionStatus: 3
        });
      } else {
        this.userServices[ind].ActionStatus = 2;
      }
    });
    this.usrData.UserServices = this.userServices;
    this._usrService.updateUser().subscribe(
      data => {
        this.loading = false;
        this.message = "User " + ActionMessage.UPDATESUCCESS.toString();
        // this.saveDocument();
        //this.clearData();
        //this.isAdd=true;
      },
      error => {
        this.loading = false;
        if (JSON.parse(error._body).Message === undefined) {
          this.message = error._body;
        } else {
          this.message = JSON.parse(error._body).Message;
        }
      }
    );
    if (this.profilePic != undefined) {
      this.updateProfilePic(this.usrData.UserId, "");
    } else {
      this.getUserDetail();
    }
  }
  setService(data: any) {
    //data.Checked = !data.Checked;
    let index = this.userServices.findIndex(
      item => item.ServiceId == data.ServiceId
    );
    if (!data.Checked) {
      if (index == -1) {
        this.userServices.push({
          ServiceId: data.ServiceId,
          SpecializeId: this.usrData.SpecializationId,
          UserId: 0,
          ActionStatus: 1
        });
      }
    } else {
      if (index > -1) {
        this.userServices.splice(index, 1);
      }
    }
  }
  getRole() {
    this.listLoading = true;
    this.roleSrv.getRoles().subscribe(
      data => {
        this.roleList = data;
      },
      error => {
        this.message = error.data;
      }
    );
  }

  getSpecialization() {
    this.listLoading = true;
    this.specSrv.getSpecializes().subscribe(
      data => {
        this.specializeList = data;
      },
      error => {
        this.message = error.data;
      }
    );
  }
  getOrganization(): void {
    this.listLoading = true;
    this.orgSrv.getOrganization().subscribe(
      data => {
        this.organizations = data;
        this.dopdownData.OrganizationId = this.organizations[0].OrgId;
      },
      error => {
        this.message = error.data;
      }
    );
  }

  getTimezone(id: number): void {
    this.listLoading = true;
    this.orgSrv.getTimezones(id).subscribe(
      data => {
        this.timezones = data.Item;
        //this.dopdownData.Timezone =  this.timezones[0].OrgId;
      },
      error => {
        this.message = error.data;
      }
    );
  }

  getCountry(): void {
    this.listLoading = true;
    this.orgSrv.getCountry().subscribe(
      data => {
        this.countries = data.Item;
        if (this.isAdd) {
          this.dopdownData.CountryID = 99;
          this.usrData.CountryCode = 91;
        }
        this.GetState();
        this.getTimezone(this.dopdownData.CountryID);
      },
      error => {
        this.message = error.data;
      }
    );
  }

  ngOnInit() {
    this.getRole();
    this.getSpecialization();
    this.getOrganization();
    this.getCountry();
    // this.usrData = null;
    var id: number;
    this.sub = this.route.params.subscribe(params => {
      if (params.hasOwnProperty("id")) {
        id = +params["id"];
        this.isAdd = false;
        this.getUsers(id);
      }
    });
  }
  ngAfterViewChecked() {
    this._sharedService.emitChange(false);
  }
  ngOnDestroy() {
    this._sharedService.emitChange(true);
  }
  addInService() {
    if (
      this.services.findIndex(
        item => item.ServiceName.toUpperCase() == this.service.toUpperCase()
      ) == -1 &&
      this.service != ""
    ) {
      this.services.push({
        Checked: true,
        ServiceId: 0,
        ServiceName: this.service
      });
      this.userServices.push({
        ServiceId: 0,
        SpecializeId: this.dopdownData.SpecializationId,
        ServiceName: this.service,
        UserId: 0,
        ActionStatus: 1
      });
    }

    this.service = "";
  }
}



// WEBPACK FOOTER //
// ./src/app/section/user/create-user/create-user.component.ts